
<div>
  <h1 class="grandTitre text-center pt-5">{{ msgRedirection }}</h1>
</div>
